import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import gradient from "../../Assets/banner-blue-pill.png";


import blogs from "./Blogs";

const categories = [
    "All",
    "Category A",
    "Category B",
    "Category C",
    "Category D",
    "Category E",
];

export default function BlogList() {
    const [activeCategory, setActiveCategory] = useState("All");
    return (
        <>
            <section className='bg-theme section-hero'>
                <Container className="header-section pb-5 pt-2">

                    <Row className='mb-4 pt-5'>
                        <Col md={11}>
                            <h2 className="heading-style-h2 pb-3 text-white">Our <span className="text-gradient-1">Blogs </span></h2>
                            <h5 className='heading-style-h5 pb-5 text-white'>Insights on building, scaling and improving digital products</h5>
                        </Col>
                    </Row>
                    <div className="pills-wrap">

                        <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                            <Image src={gradient} />
                        </div>
                    </div>
                </Container >
            </section >
            <section className="py-5 bg-light">
                <Container>
                    {/* Category Tabs */}
                    <div className="d-flex flex-wrap gap-3 justify-content-center mb-5">
                        {categories.map((category, index) => (
                            <button
                                key={index}
                                className={`rounded-pill btn px-3 ${activeCategory === category ? "bg-gradient-3 btn-outline-dark  text-white" : "bg-gradient-4"
                                    }`}
                                onClick={() => setActiveCategory(category)}
                            >
                                {category}
                            </button>
                        ))}
                    </div>
                    <Row className="g-4">
                        {blogs.map((blog) => (
                            <Col lg={4} md={6} key={blog.id}>
                                <Card className="border-0 shadow-sm h-100">
                                    <Card.Img
                                        variant="top"
                                        src={blog.image}
                                        style={{
                                            height: "220px",
                                            objectFit: "cover",
                                        }}
                                    />

                                    <Card.Body className="d-flex flex-column">
                                        <small className="text-muted mb-3">{blog.date}</small>

                                        <Card.Title className="blog-title">
                                            {blog.title}
                                        </Card.Title>

                                        <div className="d-flex justify-content-between align-items-center mt-auto pt-3 mb-3">
                                            <div className="d-flex align-items-center gap-2">
                                                <img
                                                    src="https://i.pravatar.cc/40"
                                                    alt="author"
                                                    className="author-img"
                                                />
                                                <span className="author-name">{blog.author}</span>
                                            </div>

                                            <span className="read-time">{blog.readTime}</span>
                                        </div>

                                        <Link to={`/blogs/${blog.slug}`} className="btn btn-outline-dark rounded-pill text-uppercase ms-3">READ MORE</Link>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    {/* Load More */}
                    <div className="text-center mt-5">
                        <Link className="btn btn-outline-dark rounded-pill text-uppercase ms-3">LOAD MORE</Link>
                    </div>
                </Container>
            </section>
        </>

    );
}